import React, { forwardRef } from 'react';
import '../styles/Input.css';

export const Input = forwardRef(({ 
  type = 'text', 
  label, 
  icon, 
  rightIcon, 
  onRightIconClick, 
  className = '', 
  ...props 
}, ref) => {
  return (
    <div className={`ds-input-group ${className}`}>
      {label && <label className={props.labelClassName || "ds-label"}>{label}</label>}
      <div className="ds-input-wrapper">
        {icon && (
            <span className="material-symbols-outlined ds-input-icon">
            {icon}
            </span>
        )}
        <input
            ref={ref}
            type={type}
            className={`ds-input ${!icon ? 'ds-input-no-icon' : ''}`}
            {...props}
        />
        {rightIcon && (
            <button 
            type="button" 
            className="ds-input-action" 
            onClick={onRightIconClick}
            >
            <span className="material-symbols-outlined">{rightIcon}</span>
            </button>
        )}
      </div>
    </div>
  );
});

Input.displayName = 'Input';
